import { render, staticRenderFns } from "./GeneroCard.vue?vue&type=template&id=de8f1df2"
import script from "./GeneroCard.vue?vue&type=script&lang=js"
export * from "./GeneroCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports